












import { Component, Vue } from 'vue-property-decorator'

import type { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'

import TransportError from '@/components/layouts/TransportError.vue'
import Breadcrumbs from '@/components/lib/Breadcrumbs.vue'

@Component({
  components: { TransportError, Breadcrumbs },
})
class TransportRefillView extends Vue {
  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Транспортный сервис',
      disabled: false,
      to: { name: 'main/transport' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]
}

export default TransportRefillView
